// Helper function for consistent date/time formatting
const formatDateTime = () => {
  return new Intl.DateTimeFormat("en-IN", {
    dateStyle: "medium",
    timeStyle: "short",
    timeZone: "Asia/Kolkata",
  }).format(new Date());
};

// Single reusable WhatsApp message function
export const createWhatsAppMessage = (branch, name, phone, message) => {
  return `Hello Olive Dental Clinic,%0A%0A` +
    `New Appointment Request%0A` +
    `------------------%0A` +
    `Branch: ${branch.name}%0A%0A` +
    `Patient Name: ${name}%0A` +
    `Phone: ${phone}%0A` +
    `${message ? `%0AMessage: ${message}` : ""}%0A%0A` +
    `Submitted: ${formatDateTime()}%0A%0A` +
    `Please confirm the appointment.%0A` +
    `Thank you.`;
};

export const branches = {
  mangalam: {
    id: "mangalam",
    slug: "mangalam",
    name: "Olive Dental Clinic – Mangalam",
    shortName: "Mangalam",
    
    address: {
      building: "Mangalam Town",
      road: "Koottayi Road",
      locality: "Mangalam",
      city: "Tirur",
      district: "Malappuram",
      state: "Kerala",
      pincode: "676561",
      country: "India",
      landmark: "Mangalam Town"
    },
    fullAddress: "Mangalam Town, Koottayi Road, Mangalam, Tirur, Malappuram, Kerala – 676561",
    
    contact: {
      phone: "+919947295388",
      phoneDisplay: "99472 95388",
      whatsapp: "919947295388",
      email: "olivesdentalclinic@gmail.com"
    },
    
    mapLink: "https://maps.app.goo.gl/8aPPwpq5QY9CwiDk6",
    
    coordinates: {
      lat: "",
      lng: ""
    },
    
    // FIXED: holiday: "Sunday" → "Closed"
    workingHours: {
      days: "Monday - Saturday",
      opens: "10:30",
      closes: "17:30",
      display: "Monday – Saturday: 10:30 AM – 5:30 PM",
      holiday: "Closed"
    },
    
    isMain: true,
    googleBusiness: {
      cid: "",
      placeId: "",
      reviewUrl: "",
      profileUrl: ""
    },
    
    schema: {
      type: "Dentist",
      priceRange: "₹₹",
      currenciesAccepted: "INR",
      paymentAccepted: [
        "Cash",
        "UPI",
        "Card"
      ]
    },
    
    seo: {
      title: "Best Dental Clinic in Mangalam | Olive Dental Clinic",
      description: "Olive Dental Clinic, Mangalam provides advanced dental care including Root Canal Treatment, Dental Implants, Teeth Cleaning, Aligners, Cosmetic Dentistry, Kids Dentistry and General Dentistry by experienced dental surgeons.",
      canonical: "https://olivedentals.in/mangalam",
      robots: "index, follow",
      keywords: [
        "Best Dental Clinic in Mangalam",
        "Best Dentist in Mangalam",
        "Dental Clinic Mangalam",
        "Dentist Mangalam",
        "Dentist Near Me",
        "Dental Clinic Near Me",
        "Dentist Malappuram",
        "Family Dentist",
        "Kids Dentist",
        "Smile Designing",
        "Dental Hospital Mangalam",
        "Root Canal Treatment Mangalam",
        "Dental Implants Mangalam",
        "Teeth Cleaning Mangalam",
        "Cosmetic Dentist Mangalam",
        "Olive Dental Clinic",
        "Dr Thousif Dental Clinic"
      ],
      og: {
        title: "Olive Dental Clinic - Best Dentist in Mangalam",
        description: "Expert dental care in Mangalam. Dr. Thousif Ahammed provides root canal, implants, teeth cleaning, aligners and cosmetic dentistry. Book your appointment today.",
        image: "https://olivedentals.in/og-image.jpg",
        type: "website"
      },
      twitter: {
        card: "summary_large_image",
        title: "Olive Dental Clinic - Best Dentist in Mangalam",
        description: "Expert dental care in Mangalam. Book your appointment today."
      }
    }
  },
  
  koottayi: {
    id: "koottayi",
    slug: "koottayi",
    name: "Olive Dental Clinic – Koottayi",
    shortName: "Koottayi",
    
    address: {
      building: "Lillis Bakery Building",
      road: "Tirur Road",
      locality: "Koottayi",
      city: "Tirur",
      district: "Malappuram",
      state: "Kerala",
      pincode: "676562",
      country: "India",
      landmark: "Lillis Bakery Building"
    },
    fullAddress: "Lillis Bakery Building, Tirur Road, Koottayi, Tirur, Malappuram, Kerala – 676562",
    
    contact: {
      phone: "+919544295388",
      phoneDisplay: "95442 95388",
      whatsapp: "919544295388",
      email: "olivesdentalclinic@gmail.com"
    },
    
    mapLink: "https://maps.app.goo.gl/aVtBnCYttM18MR2Y8",
    
    coordinates: {
      lat: "",
      lng: ""
    },
    
    // FIXED: holiday: "Sunday" → "Closed"
    workingHours: {
      days: "Monday - Saturday",
      opens: "09:30",
      closes: "17:30",
      display: "Monday – Saturday: 9:30 AM – 5:30 PM",
      holiday: "Closed"
    },
    
    isMain: false,
    googleBusiness: {
      cid: "",
      placeId: "",
      reviewUrl: "",
      profileUrl: ""
    },
    
    schema: {
      type: "Dentist",
      priceRange: "₹₹",
      currenciesAccepted: "INR",
      paymentAccepted: [
        "Cash",
        "UPI",
        "Card"
      ]
    },
    
    seo: {
      title: "Best Dental Clinic in Koottayi | Olive Dental Clinic",
      description: "Olive Dental Clinic, Koottayi provides advanced dental care including Root Canal Treatment, Dental Implants, Teeth Cleaning, Aligners, Cosmetic Dentistry, Kids Dentistry and General Dentistry by experienced dental surgeons.",
      canonical: "https://olivedentals.in/koottayi",
      robots: "index, follow",
      keywords: [
        "Best Dental Clinic in Koottayi",
        "Best Dentist in Koottayi",
        "Dental Clinic Koottayi",
        "Dentist Koottayi",
        "Dentist Near Me",
        "Dental Clinic Near Me",
        "Dental Clinic Tirur",
        "Best Dentist in Tirur",
        "Dentist Malappuram",
        "Family Dentist",
        "Kids Dentist",
        "Root Canal Treatment Koottayi",
        "Dental Implants Koottayi",
        "Olive Dental Clinic Koottayi",
        "Dental Clinic near Tirur"
      ],
      og: {
        title: "Olive Dental Clinic - Best Dentist in Koottayi",
        description: "Expert dental care in Koottayi. Dr. Suhainath & Dr. Thamseela provide quality dental treatments for the whole family. Book your appointment today.",
        image: "https://olivedentals.in/og-image.jpg",
        type: "website"
      },
      twitter: {
        card: "summary_large_image",
        title: "Olive Dental Clinic - Best Dentist in Koottayi",
        description: "Expert dental care in Koottayi. Book your appointment today."
      }
    }
  },
  
  vettom: {
    id: "vettom",
    slug: "vettom",
    name: "Olive Dental Clinic – Vettom",
    shortName: "Vettom",
    
    address: {
      building: "Classic Building",
      road: "Pariyapuram Road",
      locality: "Alissery",
      city: "Tirur",
      district: "Malappuram",
      state: "Kerala",
      pincode: "676102",
      country: "India",
      landmark: "Classic Building"
    },
    fullAddress: "Classic Building, Pariyapuram Road, Alissery, Vettom, Tirur, Malappuram, Kerala – 676102",
    
    contact: {
      phone: "+919847641787",
      phoneDisplay: "98476 41787",
      whatsapp: "919847641787",
      email: "olivesdentalclinic@gmail.com"
    },
    
    mapLink: "https://maps.app.goo.gl/xcD4TJHS7TB3b475A",
    
    coordinates: {
      lat: "",
      lng: ""
    },
    
    // FIXED: holiday: "Sunday" → "Closed"
    workingHours: {
      days: "Monday - Saturday",
      opens: "10:00",
      closes: "18:00",
      display: "Monday – Saturday: 10:00 AM – 6:00 PM",
      holiday: "Closed"
    },
    
    isMain: false,
    googleBusiness: {
      cid: "",
      placeId: "",
      reviewUrl: "",
      profileUrl: ""
    },
    
    schema: {
      type: "Dentist",
      priceRange: "₹₹",
      currenciesAccepted: "INR",
      paymentAccepted: [
        "Cash",
        "UPI",
        "Card"
      ]
    },
    
    seo: {
      title: "Best Dental Clinic in Vettom | Olive Dental Clinic",
      description: "Olive Dental Clinic, Vettom provides advanced dental care including Root Canal Treatment, Dental Implants, Teeth Cleaning, Aligners, Cosmetic Dentistry, Kids Dentistry and General Dentistry by experienced dental surgeons.",
      canonical: "https://olivedentals.in/vettom",
      robots: "index, follow",
      keywords: [
        "Best Dental Clinic in Vettom",
        "Best Dentist in Vettom",
        "Dental Clinic Vettom",
        "Dentist Vettom",
        "Dentist Near Me",
        "Dental Clinic Near Me",
        "Dental Clinic Pariyapuram",
        "Best Dentist in Pariyapuram",
        "Dentist Malappuram",
        "Family Dentist",
        "Kids Dentist",
        "General Dentistry Vettom",
        "Cosmetic Dentist Vettom",
        "Olive Dental Clinic Vettom",
        "Dental Clinic near Vettom"
      ],
      og: {
        title: "Olive Dental Clinic - Best Dentist in Vettom",
        description: "Expert dental care in Vettom. Dr. Afsa Abdulkader provides compassionate general dentistry and preventive care. Book your appointment today.",
        image: "https://olivedentals.in/og-image.jpg",
        type: "website"
      },
      twitter: {
        card: "summary_large_image",
        title: "Olive Dental Clinic - Best Dentist in Vettom",
        description: "Expert dental care in Vettom. Book your appointment today."
      }
    }
  }
};

// Export helpers
export const branchList = Object.values(branches);
export const branchSlugs = Object.keys(branches);

export const getBranchBySlug = (slug) => {
  return branches[slug] || branches.mangalam;
};

export const getBranchName = (slug) => {
  return branches[slug]?.name || branches.mangalam.name;
};

export const getBranchShortName = (slug) => {
  return branches[slug]?.shortName || branches.mangalam.shortName;
};

export const getBranchPhone = (slug) => {
  return branches[slug]?.contact?.phone || branches.mangalam.contact.phone;
};

export const getBranchPhoneDisplay = (slug) => {
  return branches[slug]?.contact?.phoneDisplay || branches.mangalam.contact.phoneDisplay;
};

export const getBranchWhatsApp = (slug) => {
  return branches[slug]?.contact?.whatsapp || branches.mangalam.contact.whatsapp;
};

export const getBranchEmail = (slug) => {
  return branches[slug]?.contact?.email || branches.mangalam.contact.email;
};

export const getBranchFullAddress = (slug) => {
  return branches[slug]?.fullAddress || branches.mangalam.fullAddress;
};

export const getBranchMapLink = (slug) => {
  return branches[slug]?.mapLink || branches.mangalam.mapLink;
};

export const getBranchWorkingHours = (slug) => {
  return branches[slug]?.workingHours || branches.mangalam.workingHours;
};

export const getBranchSEO = (slug) => {
  return branches[slug]?.seo || branches.mangalam.seo;
};

export const getBranchCoordinates = (slug) => {
  return branches[slug]?.coordinates || branches.mangalam.coordinates;
};

export const getBranchSchema = (slug) => {
  return branches[slug]?.schema || branches.mangalam.schema;
};

export const getBranchGoogleBusiness = (slug) => {
  return branches[slug]?.googleBusiness || branches.mangalam.googleBusiness;
};

export const getAllBranchNames = () => {
  return branchList.map(b => b.shortName);
};

export const getBranchOptions = () => {
  return branchList.map(b => ({
    id: b.id,
    name: b.name,
    shortName: b.shortName,
    slug: b.slug
  }));
};

export const getBranchById = (id) => {
  return branches[id] || branches.mangalam;
};

export const getBranchAddressObject = (slug) => {
  return branches[slug]?.address || branches.mangalam.address;
};